<template>
    <form class="calendar_tab form-horizontal calendar-tab-pc">
        <div class="calendar-result " v-show="todolist">
            <div class="panel panel-default">
                <div class="panel-heading bg-color-skin">
                    <div class="col-xs-2 pull-left align-left"></div>
                    <div class="col-xs-8 pull-left align-center">
                        <label> {{ labels[nowLang].nameCodapp }} </label>
                    </div>
                    <div class="col-xs-2 pull-right align-right" title="Add Todolist">
                        <i class="fa fa-plus-circle " aria-hidden="true" @click="addTodoList()"></i>
                    </div>
                </div>
                <filter-date :showTabDate="showTabDate"/>

                <div class="body-pc">
                    <template v-for="(todolist, index) in sortByTimstrt(filterCalendarTab({ tab: 'tab4', calendarTabRows: calendarTab4.rows }))" >
                      <div class="panel-body">
                            <div class="row">
                            <div class="col-xs-12">
                                <label class="set-topic-tab4" >{{ todolist.topic }}</label>
                            </div>
                            <div class="col-xs-8  set-font-tab4">
                                <i class="fa fa-clock-o i3" aria-hidden="true"></i> <label class="text_time1 set-font-color-tab" >{{ timeFormat(todolist.timstrt) }} - {{ timeFormat(todolist.timend) }}</label>
                            </div>
                            <div class="col-xs-4  set-font-tab4">
                                <todo-checkbox  v-model="todolist.checked" 
                                                @saveTodoListChecked="saveTodoListChecked(todolist)" ></todo-checkbox>
                            </div>
                            <div class="col-xs-8 set-font-tab4">
                                <i class="fa fa-map-marker i2" aria-hidden="true"></i> <label class="text_time1 set-font-color-tab" >{{ todolist.place }}</label>
                            </div>
                            <div class="col-xs-4 set-font-tab4">
                                <i class="fa fa-trash icon_bin" aria-hidden="true" @click="deleteTodoList(todolist)" ></i>
                                <i class="fa fa-pencil icon_manage " aria-hidden="true" @click="editTodoList(todolist)"></i>
                            </div>
                            </div>
                      </div>
                      <hr>
                    </template>
                </div>
            </div>
        </div>
        <div class="calendar-result" v-show="addlist">
            <div class="panel panel-default">
              <div class="panel-heading bg-color-skin">
                    <div class="col-xs-2 pull-left align-left"></div>
                    <div class="col-xs-8 pull-left align-center">
                        <label> {{ labels[nowLang].nameCodapp }} </label>
                    </div>
                    <div class="col-xs-2 pull-right align-right"></div>
                </div>
                <div class="panel-body">
                    <div class="row row1">
                        <div class="col-xs-3 title top">
                            <div class="form-group">
                            <label class="control-label">{{ labels[nowLang].detail }}</label>
                            </div>
                        </div>
                        <div class="col-xs-9 top">
                            <div class="form-group">
                                <input type="text" class="form-control border-color-skin" v-model="sendParams.topic"
                                       v-validate="'required'" name="topic" :class="{ 'input-error' : errors.has('topic') }" />
                                <div class="text-error" v-show="errors.has('topic')">{{ errors.first('topic') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row row1">
                        <div class="col-xs-3 title">
                        <div class="form-group">
                            <label class="control-label"><i class="fa fa-clock-o i3" aria-hidden="true"></i></label>
                        </div>
                        </div>
                        <div class="col-xs-3 time_width">
                            <div class="form-group">
                            <hrms-timepicker  v-model="sendParams.timstrt"
                                              v-validate="'required|date_format:HH:mm'"
                                              data-vv-name="timstrt"
                                              data-vv-value-path="inputTime"
                                              :class="{ 'input-error' : errors.has('timstrt') }"
                                              :has-error="errors.has('timstrt')" />
                            <div class="text-error" v-show="errors.has('timstrt')">{{ errors.first('timstrt') }}</div>
                        </div>
                        </div>
                        <div class="col-xs-1 time_to">
                            <div class="form-group">
                            <label class="col-sm-1 control-label">-</label>
                        </div>
                        </div>
                        <div class="col-xs-3 time_width">
                            <div class="form-group">
                            <hrms-timepicker  v-model="sendParams.timend"
                                              v-validate="'required|date_format:HH:mm'"
                                              data-vv-name="timend"
                                              data-vv-value-path="inputTime"
                                              :class="{ 'input-error' : errors.has('timend') }"
                                              :has-error="errors.has('timend')" />
                            <div class="text-error" v-show="errors.has('timend')">{{ errors.first('timend') }}</div>
                        </div>
                        </div>
                    </div>
                  <div class="row row1">
                    <div class="col-xs-3 title">
                        <div class="form-group">
                            <label class="control-label"><i class="fa fa-map-marker i2" aria-hidden="true"></i></label>
                        </div>
                    </div>
                    <div class="col-xs-9">
                        <div class="form-group">
                            <input type="text" class="form-control border-color-skin" v-model="sendParams.place"
                                   v-validate="'required'" name="place" :class="{ 'input-error' : errors.has('place') }" />
                            <div class="text-error" v-show="errors.has('place')">{{ errors.first('place') }}</div>
                        </div>
                    </div>
                </div>
                  <div class="row row1" align="center">
                    <button type="button" class="btn bg-color-skin" @click="saveTodoList()">{{ labels[nowLang].save }}</button>
                    <button type="button" class="btn bg-color-skin" @click="toggleList()">{{ labels[nowLang].cancel }}</button>
                  </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import todoCheckbox from 'components/calendar/todoCheckbox'
import filterDate from 'components/calendar/filter_date'
import _ from 'lodash'

export default {
  name: 'calendar_tab4',
  props: [ 'calendarTab4', 'filterCalendarTab', 'selectedDate', 'selectedMonth', 'selectedYear', 'postCalendarTab4', 'deleteCalendarTab4', 'postCalendarTab4Checked', 'nowLang', 'checkCalendarMain' ],
  data () {
    return {
      todolist: true,
      addlist: false,
      sendParams: this.setDefaultParams(),
      labels: {
        en: {
          nameCodapp: 'To Do List',
          detail: 'Detail',
          save: 'Save',
          cancel: 'Back'
        },
        th: {
          nameCodapp: 'To Do List',
          detail: 'รายละเอียด',
          save: 'บันทึก',
          cancel: 'ย้อนกลับ'
        }
      }
    }
  },
  methods: {
    sortByTimstrt (todolists) {
      todolists.sort(function (todolistA, todolistB) {
        return todolistA.timstrt.replace(':', '') - todolistB.timstrt.replace(':', '')
      })
      return todolists
    },
    timeFormat (time) {
      let timeReplaced = time.replace(':', '')
      return timeReplaced.substr(0, 2) + ':' + timeReplaced.substr(2, 2)
    },
    setDefaultParams (flgsave) {
      return {
        id: 0,
        date: 0,
        month: 0,
        year: 0,
        numseq: 0,
        topic: '',
        timstrt: '',
        timend: '',
        checked: 'N',
        place: '',
        flgsave: flgsave
      }
    },
    toggleList () {
      this.todolist = !this.todolist
      this.addlist = !this.addlist
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    addTodoList () {
      this.sendParams = this.setDefaultParams('add')
      this.sendParams.date = this.selectedDate
      this.sendParams.month = this.selectedMonth
      this.sendParams.year = this.selectedYear
      this.sendParams.id = this.calendarTab4.rows.length
      this.toggleList()
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    editTodoList (todolist) {
      this.sendParams = this.setDefaultParams('edit')
      this.sendParams.date = todolist.date
      this.sendParams.month = todolist.month
      this.sendParams.year = todolist.year
      this.sendParams.id = todolist.id
      this.sendParams.numseq = todolist.numseq
      this.sendParams.topic = todolist.topic
      this.sendParams.timstrt = todolist.timstrt
      this.sendParams.timend = todolist.timend
      this.sendParams.place = todolist.place
      this.sendParams.checked = todolist.checked
      this.toggleList()
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    deleteTodoList (todolist) {
      this.sendParams = this.setDefaultParams('delete')
      this.sendParams.date = todolist.date
      this.sendParams.month = todolist.month
      this.sendParams.year = todolist.year
      this.sendParams.numseq = todolist.numseq
      this.sendParams.id = todolist.id
      this.deleteCalendarTab4(this.sendParams)
      this.checkCalendarMain(parseInt(this.sendParams.date))
    },
    saveTodoList () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let calendarTab4Row = {
            p_dtework: _.padStart(this.sendParams.date, 2, '0') + '' + _.padStart(this.sendParams.month, 2, '0') + '' + this.sendParams.year,
            p_numseq: this.sendParams.numseq,
            p_detail: this.sendParams.topic,
            p_timstrt: this.sendParams.timstrt,
            p_timend: this.sendParams.timend,
            p_location: this.sendParams.place,
            p_flgchk: this.sendParams.checked
          }
          this.postCalendarTab4({ sendParams: this.sendParams, calendarTab4Row: calendarTab4Row })
          if (this.sendParams.flgsave === 'add') {
            this.sendParams = this.setDefaultParams()
            this.toggleList()
            this.checkCalendarMain(parseInt(this.sendParams.date))
          }
        }
      })
    },
    saveTodoListChecked (todolist) {
      this.sendParams = this.setDefaultParams('checked')
      this.sendParams.date = todolist.date
      this.sendParams.month = todolist.month
      this.sendParams.year = todolist.year
      this.sendParams.numseq = todolist.numseq

      this.postCalendarTab4Checked(this.sendParams)
    }
  },
  components: {
    todoCheckbox,
    filterDate
  }
}
</script>


// WEBPACK FOOTER //
// calendar_tab4.vue?3b28de9f